import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const SkeletonBlogCard = styled(Box)({
    boxShadow: '0px 4px 12px 4px rgba(63, 81, 181, 0.05)',
    background: '#FFFFFF',
    borderRadius: '0.8em',
    height: '23em',
    width: '20em',
});

export const SkeletonBlogContent = styled(Box)({
    padding: '1.71em',
});

